import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({
  children,
  variant = "contained",
  fullWidth = true,
  sx = {},
  ...props
}) => {
  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      sx={{
        backgroundColor: "rgba(204, 158, 73, 1)",
        color: "#FFFFFF",
        fontSize: "16px",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: "200px",
        height: "60px",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#B8941F",
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: "#A0821B",
          boxShadow: "none",
        },
        "&:disabled": {
          backgroundColor: "#E0E0E0",
          color: "#999999",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;